<template lang="pug">
.alert-box
	.has-text-centered
		.columns.is-mobile.is-centered.is-vcentered.is-multiline.columns-no-padding-vertical.margin-top-xs
			.column.is-narrow
				| {{ $t('home.section_intro.app1') }}
			.column.is-narrow.no-padding-left
				img(src="/icon.png" alt="" draggable="false" style="width:2rem; display:block;")
			.column.is-narrow.no-padding-left
				strong {{ $t('home.section_intro.app2') }}
			.column.is-narrow.no-padding-left(style="max-width:90vw;")
				| {{ $t('home.section_intro.app3') }}
		.app-container
			android-app
			ios-app

</template>

<script>
import AndroidApp from '../../app/AndroidApp.vue'
import IosApp from '../../app/IosApp.vue'

export default {
	components: {
		AndroidApp,
		IosApp
	},
	name: 'IntroApp'
}
</script>
